import { useId, useRef, useState } from 'react'
import styled from 'styled-components'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import Popover from './Popover'
import { INK, LINK, MUTED } from './ui'

const InfoPopover = ({ label, title, text, children }) => {
  const btnRef = useRef(null)
  const popoverId = useId()
  const [open, setOpen] = useState(false)
  return (
    <>
      <InfoButton
        ref={btnRef}
        type='button'
        aria-label={text ? undefined : label}
        aria-haspopup='dialog'
        aria-expanded={open}
        aria-controls={popoverId}
        onClick={e => { e.stopPropagation(); setOpen(o => !o) }}
      >
        <InfoOutlinedIcon style={{ fontSize: 18 }} aria-hidden='true' />
        {text && <span>{text}</span>}
      </InfoButton>
      <Popover id={popoverId} anchorEl={btnRef.current} open={open} onClose={() => setOpen(false)} label={title} width={360} closeLabel='Close this explanation'>
        <PopTitle>{title}</PopTitle>
        {children}
      </Popover>
    </>
  )
}

export default InfoPopover

const InfoButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  min-width: 40px;
  min-height: 40px;
  padding: 0 6px;
  border: none;
  background: none;
  color: ${LINK};
  font: inherit;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  &:focus-visible { outline: 2px solid ${INK}; outline-offset: 2px; border-radius: 6px; }
`

const PopTitle = styled.h4`
  margin: 0 0 8px;
  font-size: 16px;
  font-weight: 700;
  color: ${INK};
`

export const PopLead = styled.p`
  margin: 0 0 10px;
  font-size: 15px;
  line-height: 1.5;
  color: ${MUTED};
`

export const PopSubTitle = styled.h5`
  margin: 12px 0 6px;
  font-size: 14px;
  font-weight: 700;
  color: ${INK};
`

export const PopList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const PopItem = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
  font-size: 15px;
  line-height: 1.45;
  color: ${MUTED};
  strong { color: ${INK}; }
`

export const PopDot = styled.span`
  flex: 0 0 auto;
  width: 10px;
  height: 10px;
  margin-top: 6px;
  border-radius: 50%;
`
